import { useToast } from '@pancakeswap/uikit'
import { useCallback } from 'react'
import styled from 'styled-components'
import { Icon } from 'views/TokenPages/icons'
import { EXPLORER } from '../config'

/** The two small actions that go with any address or hash on the competition pages: copy the whole value, open it on BscScan. 44 px targets, 16 px drawn. */
export const IconAction = styled.button`
  all: unset;
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: none;
  width: 44px;
  height: 44px;
  margin: -10px 0;
  border-radius: 12px;
  cursor: pointer;
  color: ${({ theme }) => theme.colors.textSubtle};
  &:hover {
    color: ${({ theme }) => theme.colors.primary};
  }
  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors.primary};
    outline-offset: -4px;
  }
`
export const IconLink = IconAction.withComponent('a')

/** Copies `value` (clipboard API, with the old textarea way as a fallback for browsers that refuse it) and says so. */
export function useCopy() {
  const { toastSuccess } = useToast()
  return useCallback(
    async (value: string) => {
      try {
        await navigator.clipboard.writeText(value)
      } catch {
        const ta = document.createElement('textarea')
        ta.value = value
        ta.setAttribute('readonly', '')
        ta.style.position = 'fixed'
        ta.style.opacity = '0'
        document.body.appendChild(ta)
        ta.select()
        try {
          document.execCommand('copy')
        } catch {
          /* nothing else to try */
        }
        document.body.removeChild(ta)
      }
      toastSuccess('Copied', value)
    },
    [toastSuccess],
  )
}

export function CopyButton({ value, label, testId = 'v3-copy' }: { value: string; label: string; testId?: string }) {
  const copy = useCopy()
  return (
    <IconAction type="button" onClick={() => copy(value)} aria-label={`Copy ${label} ${value}`} data-testid={testId}>
      <Icon name="copy" size={16} />
    </IconAction>
  )
}

export function ScanLink({ value, kind = 'address', label, testId }: { value: string; kind?: 'address' | 'tx'; label: string; testId?: string }) {
  return (
    <IconLink href={`${EXPLORER}/${kind}/${value}`} target="_blank" rel="noopener noreferrer" aria-label={`Open ${label} on BscScan`} data-testid={testId}>
      <Icon name="external" size={16} />
    </IconLink>
  )
}
